export const FETCH_PREF_REQUEST = "FETCH_PREF_REQUEST";
export const FETCH_PREF_SUCCESS = "FETCH_PREF_SUCCESS";
export const FETCH_PREF_FAILURE = "FETCH_PREF_FAILURE";
export const UPDATE_PREF_REQUEST = "UPDATE_PREF_REQUEST";
export const UPDATE_PREF_SUCCESS = "UPDATE_PREF_SUCCESS";
export const UPDATE_PREF_FAILURE = "UPDATE_PREF_FAILURE";
export const CLEAR_ALL_PREF = "CLEAR_ALL_PREF";
